import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

export const SafeApiErrors = {
    // сейф уже переполнен
    SAFE_ERROR_ARCHIVE_LIMIT: 'CONDITION/ARCHIVE_LIMIT',
    SAFE_ERROR_NOT_OVERQUOTA: 'CONDITION/NOT_OVERQUOTA',
    SAFE_ERROR_EMPTY: 'CONDITION/EMPTY',
    // невозможно все файлы выгрузить места не хватает
    SAFE_ERROR_N_SPACE: 'CONDITION/NOSPC',
    NOT_EXISTS: 'NOT_EXISTS',
    INTERNAl: 'INTERNAl',
};

export class MoveAllToSafeAPICall extends APICallV4 {
    _method = 'archive/trashbin';
    _type: Method = 'post';
}

export class MoveToSafeAPICall extends APICallV4<any, { paths: string[] }> {
    _method = 'archive/add';
    _type: Method = 'post';
}

export class RestoreFromSafeAPICall extends APICallV4 {
    _method = 'archive/restore/all';
    _type: Method = 'post';
}

export class GetSafeStatusAPICall extends APICallV4 {
    _method = 'archive/status';
    _type: Method = 'get';
}

export class RemoveFromSafeAPICall extends APICallV4 {
    _method = 'archive/clear';
    _type: Method = 'post';
}
